import {Component} from "react";
import * as React from "react";
import SelectableCard from "./SelectableCard";

export interface YearGroupingSuggestion
{
    name: string;
    yearGroupingNames: string[];
}

const SUGGESTIONS: YearGroupingSuggestion[] = [
    {
        name: "Key Stages",
        yearGroupingNames: ["EYFS","KS1","KS2","KS3","KS4","KS5"]
    },
    {
        name: "Year Groups",
        yearGroupingNames: ["Reception", "Year 01", "Year 02", "Year 03", "Year 04", "Year 05", "Year 06", "Year 07" ,"Year 08" ,"Year 09", "Year 10", "Year 11", "Year 12", "Year 13"]
    },
    {
        name: "Courses",
        yearGroupingNames: ["Year 07", "Year 08", "Year 09", "GCSE", "Sixth Form"]
    },
    {
        name: "Primary School",
        yearGroupingNames: ["Reception", "Year 01", "Year 02", "Year 03", "Year 04", "Year 05", "Year 06"]
    },
    {
        name: "Custom",
        yearGroupingNames: ["Custom A", "Custom B", "Custom C"]
    }
];

export interface YearGroupingSuggestionsProps
{
    onSuggestionSelected(suggestion: YearGroupingSuggestion): void;
}

interface YearGroupingSuggestionsState
{
    selectedSuggestionName?: string;
}

export default class YearGroupingSuggestions extends Component<YearGroupingSuggestionsProps,YearGroupingSuggestionsState>
{

    constructor(props: Readonly<YearGroupingSuggestionsProps>) {
        super(props);

        this.state = {
            selectedSuggestionName: undefined
        };
    }

    public componentDidMount() {
    }
    
    private suggestionClicked = (suggestion: YearGroupingSuggestion): void  => {
        this.setState({
            selectedSuggestionName: suggestion.name
        });
        
        this.props.onSuggestionSelected(suggestion);
    }
    
    public render() {
        
        const suggestionCards = SUGGESTIONS.map(suggestion => <SelectableCard title={suggestion.name} selected={this.state.selectedSuggestionName === suggestion.name} onClick={() => this.suggestionClicked(suggestion)}/>);
        
        return (
            <div className={"m-bottom-1rem"}>
                <h4 className={"text-align-center"}>Suggestions</h4>
                <div className={"flex-row flex--align-items-center flex--justify-content-center flex--flow-wrap"}>
                    {suggestionCards}
                </div>
            </div>

        );
    }
}